module.exports = __webpack_public_path__ + "img/category-fishing-game-hover.5f8e1547.png";